$(function() {
  var $oe_menu = $('#main-menu');
  var $oe_menu_items = $oe_menu.children('li');
  var $oe_overlay = $('#oe_overlay');

  $oe_menu_items.bind('mouseenter',function(){
    var $this = $(this);

    $this.addClass('selected');

    if($this.children('div').length) {
      $this.addClass('slided');
      $oe_overlay.height($this.children('div').height() + 175);
      $this.children('div').css('z-index','9999').stop(true,true).
        slideDown(200,function(){
          $oe_menu_items.not('.slided').children('div').hide();
          $this.removeClass('slided');
          if( ! $this.hasClass('selected')){
            $this.children('div').hide();
          }
        });
    } else {
      $oe_overlay.height( 325);
    }
  }).bind('mouseleave',function(){
    var $this = $(this);
    $this.removeClass('selected').children('div').hide();
  });

  $oe_menu.bind('mouseenter',function(){
    var $this = $(this);
    $oe_overlay.stop(true,true).show().fadeTo(200, 0.65);
    $this.addClass('hovered');
  }).bind('mouseleave',function(){
    var $this = $(this);
    $this.removeClass('hovered');
    $oe_overlay.stop(true,true).fadeTo(200, 0, function() {
      $oe_overlay.hide();
    });
    $oe_menu_items.children('div').hide();
  })
});
